import { render, staticRenderFns } from "./ShopcartList.vue?vue&type=template&id=f6ff6580&scoped=true&"
import script from "./ShopcartList.vue?vue&type=script&lang=js&"
export * from "./ShopcartList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ff6580",
  null
  
)

export default component.exports